import React from 'react';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '../../../../../components/select';
import { MenuItem } from '@mui/material';
import i18n from '../../../../../i18';

export const FilterField = ({ items, selectedItem, changeValue }) => {
    return (
        <FormControl fullWidth>
            <InputLabel id="filter">{i18n.t('text.chooseRole')}</InputLabel>
            <Select
                labelId="filter"
                id="filter-select"
                value={
                    selectedItem
                        ? items.find((item) => item.id === selectedItem)?.id
                        : ''
                }
                label={i18n.t('text.chooseRole')}
                onChange={(event) => changeValue(event.target.value)}
            >
                {items.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                        {item?.name || ''}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};
